import { ControlPackage } from '@controls/Base';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { createElement } from 'react';
import Control from './Control';
import ComboBox from './ComboBox';
import Props from './Props';
import PropsDescriptor from './PropsDescriptor';
import renderFDO from './RenderFDO';

const createComboBox = (parentId?: number | undefined): Control => ({
    globalId: -1,
    parentId,
    name: 'NewComboBox',
    type: 'combo-box',
    properties: {
        position: {
            placement: 'precise',
            top: 0,
            left: 0,
            width: 96,
            height: 16,
        },
        fontFace: 'arial',
        fontSize: 12,
        fontBold: false,
        fontItalic: false,
        fontUnderline: false,
    },
});

const upgradePropsVersion = (props: Props) => ({ ...props });

const comboBoxPackage: ControlPackage<Props, Control> = {
    type: 'combo-box',
    icon: solid('square-caret-down'),
    canHaveChildren: true,
    canHaveAction: false,
    validParentTypes: ['window'],
    factory: createComboBox,
    propDescriptors: PropsDescriptor,
    // eslint-disable-next-line react/no-children-prop
    renderDesigner: (controlId, children) => createElement(ComboBox, { controlId, children }),
    renderFDO,
    upgradePropsVersion,
};

export default comboBoxPackage;
